// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ProcurementQueries } from '../../../../types/server/modules/procurement/queries';

export type * from '../../../../types/server/modules/procurement/queries';

export const createQueries = ( requests: Requests ): ProcurementQueries => ({
  ProcurementSuppliers: ( params?, headers? ) => {
        return requests.get( `/procurement/suppliers/:supplierId?`, params, headers );
      },
  ProcurementPurchaseOrders: ( params?, headers? ) => {
        return requests.get( `/procurement/purchase-orders/:purchaseOrderId?`, params, headers );
      },
  ProcurementItemSourcing: ( params?, headers? ) => {
        return requests.get( `/procurement/item-sourcing/:itemId?`, params, headers );
      }
});
